import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { NgModel } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { EventCustomRegFieldAvailValues } from 'src/app/events-v4/shared/custom-reg-fields/event-custom-reg-field-avail-values.model';
import { EventCustomRegField } from 'src/app/events-v4/shared/custom-reg-fields/event-custom-reg-field.model';
import { RegistrationCustomRegFieldResponse } from 'src/app/events-v4/shared/registration/registration-custom-reg-field-response.model';
import { UtilService } from 'src/app/shared';
import { IValidationComponent } from 'src/app/shared/widgets/component/ivalidation.component';
import { ValidationResult } from 'src/app/shared/widgets/validators/validation-result.model';

@Component({
  selector: 'wl-event-v4-registration-custom-reg-field',
  templateUrl: 'event-v4-registration-custom-field.component.html',
    standalone: false
})
export class EventV4RegistrationCustomFieldComponent implements OnInit, IValidationComponent {
  @Input('customField') customField: EventCustomRegField;
  @Input() public get response(): RegistrationCustomRegFieldResponse {
    return this._response;
  }
  @ViewChild('numericInputNgModel', { static: false }) public _numericInputNgModel: NgModel;

  public set response(value: RegistrationCustomRegFieldResponse) {
    // Web Api's Newtonsoft JSON serializer caplitalizes booleans
    // not to mention old V2 events (built in VB) have True and False for checkbox responses
    if (value && this.customField && this.customField.UiControlType == 'Checkbox' && value.Response && typeof value.Response == 'string') {
      if (value.Response.toLowerCase() == 'true') value.Response = <string>(<any>true);
      else if (value.Response.toLowerCase() == 'false') value.Response = <string>(<any>false);
    }

    this._response = value;
  }

  @Output() responseChange = new EventEmitter<RegistrationCustomRegFieldResponse>();

  public _utilService: UtilService;
  public _response: RegistrationCustomRegFieldResponse;

  public get isCheckBox(): boolean {
    return this.customField && this.customField.UiControlType == 'Checkbox';
  }
  public get isDropDownList(): boolean {
    return this.customField && this.customField.UiControlType == 'DropdownList';
  }
  public get isInteger(): boolean {
    return this.customField && this._utilService.startswith(this.customField.UiControlType, 'NumberInputDecim');
  }
  public get isDecimal(): boolean {
    return this.customField && this._utilService.startswith(this.customField.UiControlType, 'NumberInputNoDecim');
  }
  public get isTextBox(): boolean {
    return this.customField && this.customField.UiControlType == 'TextboxSingleLine';
  }
  public get isTextArea(): boolean {
    return this.customField && this.customField.UiControlType == 'TextboxMultiLine';
  }

  public constructor(public _translateService: TranslateService, utilService: UtilService) {
    this._utilService = utilService;
  }

  ngOnInit() {}

  public getValidationResult = (): ValidationResult => {
    let valid = new ValidationResult();
    valid.isValid = true;

    if (this.customField.UiControlType == 'DropdownList') {
      // valid.isValid = this.response.UnitsAvailable == 0 || this.response.UnitsAvailable > this.response.UnitsTaken
    } else if (this.isDecimal || this.isInteger) {
      valid.isValid = this._numericInputNgModel.valid;
    }

    return valid;
  };

  /**
   * only for dropdown types
   */
  public onDropdownSelectedValueChange(): void {
    if (this.customField.UiControlType != 'DropdownList') return;

    let selectedAvailableValue: EventCustomRegFieldAvailValues = this.customField.AvailableValues.find(
      av => av.Id == this.response.EventCustomRegFieldAvailValuesId
    );

    if (this.response) this.response.Response = selectedAvailableValue ? selectedAvailableValue.Value : '';

    this.responseChange.emit(this.response);
  }

  public hasItemsAvailable = (): boolean => {
    if (this.customField.UiControlType != 'DropdownList' || this.response.EventCustomRegFieldAvailValuesId <= 0) return false;
    let selectedAvailableValue =
      this.response && this.customField.AvailableValues.find(av => av.Id == this.response.EventCustomRegFieldAvailValuesId);
    return (
      selectedAvailableValue &&
      selectedAvailableValue &&
      selectedAvailableValue.UnitsAvailable > 0 &&
      selectedAvailableValue.UnitsTaken >= selectedAvailableValue.UnitsAvailable
    );
  };

  /**
   * gets the text for the dropdown
   * @param availableValue
   */
  public getAvailableValueOptionTextForDropdownType(availableValue: EventCustomRegFieldAvailValues): string {
    let suffix: string = '';
    //{{fieldValue.Descr}} ({{fieldValue.Amount|currency}}) {{fieldValue.UnitsAvailable - fieldValue.UnitsTaken}}
    if (availableValue.UnitsAvailable > availableValue.UnitsTaken) {
      suffix =
        ' ' +
        (availableValue.UnitsAvailable - availableValue.UnitsTaken).toString() +
        ' ' +
        this._translateService.instant('common.available');
    } else if (availableValue.UnitsAvailable > 0) suffix = ' (' + this._translateService.instant('common.unavailable') + ')';
    if (availableValue.Amount > 0)
      suffix = ' (' + availableValue.Amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) + ') ' + suffix;
    return (availableValue.Descr && availableValue.Descr.search(/\S/) > -1 ? availableValue.Descr : availableValue.Value) + suffix;
  }
}
